export default __webpack_public_path__ + "static/patchion-da9d45b45786fa409ef788903de7aebe.png";